export const API_BASE_URL = `${process.env.REACT_APP_CUSTOMER_API_ENDPOINT}api/cm`;
